import React, { useState } from "react";

export function SelectUserKidModal(props) {
  const [selectUserKid, setSelectUserKid] = useState(() => {
    let newArr = [];
      props.listUserKids.forEach(element => {
        newArr.push({
          userKidId: element.userKidId,
          canUse: element.canUse,
          checked: 0
        });
      });
      return newArr;
    }
  );
  const [errorMessage, setErrorMessage] = useState('');
  
  const changeSelectUserKid = (value, index) => {
    let tmp = [...selectUserKid];
    tmp[index].checked = value;
    setSelectUserKid(tmp);
  }

  const gotoUseGochiKid = () => {
    let arr = [];
    props.setChoiceUserKidIds(() => []);
    selectUserKid.forEach(element => {
      if (element.checked) {
        arr.push(`userKidIds=${element.userKidId}`);
        props.setChoiceUserKidIds(ids => [...ids, element.userKidId]);
      }
    });
    const accessToken = props.accessToken ? "&accessToken=" + props.accessToken : "";
    const accessCode = props.accessCode ? "&accessCode=" + props.accessCode : "";
    const gochiKidGroupId = props.gochiKidGroupId ? "&gochiKidGroupId=" + props.gochiKidGroupId : "";
    if (arr.length <=0) {
      setErrorMessage('必須入力です');
    } else {
      let userKidIds = arr.join("&");
      if (props.choiceMenuId) {
        window.location.href = `/kodomo/use?shopId=${props.choiceShopId}&menuId=${props.choiceMenuId}&${userKidIds}${gochiKidGroupId}${accessToken}${accessCode}`;
      } else {
        // menu price
        props.onHide();
        props.handleOpenInputGochiKidPriceModal(props.choiceShopId);
      }
    }
  }

  return (
    <div
      className={`modal modal-profile modal-profile-02 modal-02 modal-lg select-user-kid-modal ${props.isShow ? 'is-show' : ''}`}
      tabIndex={-1}
    >
      <div className="header-register-user-kid">
        <button
          className="modal-btn modal-btn-close"
          id="modalClose"
          onClick={props.onHide}
          type="button"
        >
          <svg className="icon">
            <title>閉じる</title>
            <use xlinkHref="/assets/img/common/icon.svg#times" />
          </svg>
        </button>
      </div>
      <div className="title-modal-register">
        <div className="title">利用するお子さまの選択</div>
      </div>
      <div className="modal-body body-modal-register">
        <div className="title-warning">
          <div className="dot-red"></div>
          必須入力ですので、必ずご入力お願い致します
        </div>
        <div className="register-poor">
          <div className="register-title mt-16px">
            <div className="dot-red"></div>
            お子さま選択
          </div>
          <div className="form-block">
            {props.listUserKids.map((item, index) => {
              return (
                <div className="field field-checkbox" key={item.userKidId}>
                  <label>
                    <input
                      className="before-icon"
                      name="bbbb"
                      type="checkbox"
                      disabled={!item.canUse}
                      checked={selectUserKid[index].checked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          changeSelectUserKid(1, index);
                        } else {
                          changeSelectUserKid(0, index);
                        }
                      }}
                    />
                    <i className="icon" />
                    <span className="select-name-user-kid">{item.displayName}</span>
                  </label>
                </div>
              )
            })}
          </div>
          <div className="title-warning">{errorMessage}</div>
        </div>
      </div>
      <div className="modal-footer">
        <div>
          <button
            onClick={() => gotoUseGochiKid()}
            id="submitConfirm"
            className='btn btn-rect btn-confirm'
          >
            確定する
          </button>
        </div>
        <div>
          <button
            onClick={props.onHide}
            id="submitConfirm"
            className={'btn btn-outline-rect btn-text'}
          >
            前の画面に戻る
          </button>
        </div>
      </div>
    </div>
  ); 
}
